import { application } from "./application"
import Logger from '../lib/logger'
// Auto-generated controller registration table.
// Naming convention: <identifier>_controller.{js,ts} (kebab-case).
// Regenerate after adding/removing controllers: npm run generate-controllers
import { controllers } from "./_generated_registrations"

const failed = []
controllers.forEach(([identifier, controller]) => {
  try {
    application.register(identifier, controller)
  } catch (error) {
    Logger.error(`Failed to register controller: ${identifier}`, error)
    failed.push(identifier)
  }
})

if (failed.length > 0) {
  Logger.error(`Some controllers failed to register: ${failed.join(', ')}`)
} else {
  Logger.debug(`All ${controllers.length} controllers registered successfully`)
}
